import React, { useState } from "react";
import toast from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import "./styles/AuthStyles.css";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import {
  MDBBtn,
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBCard,
  MDBCardBody,
  MDBInput,
} from "mdb-react-ui-kit";
import "./newLogin.css";
import { BASE_URL } from "../../Routes/global-env";
import Layout from "../../Layout/Layout";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [answer, setAnswer] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const navigate = useNavigate();
  const handleSubmit = async (e) => {
    e.preventDefault();
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Access-Control-Allow-Origin", "http://localhost:3000");
    myHeaders.append("Access-Control-Allow-Credentials", "true");
    myHeaders.append("Access-Control-Allow-Headers", "Authorization");

    var raw = JSON.stringify({
      email: email,
      newPassword: newPassword,
      answer: answer,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
    };

    fetch(`${BASE_URL}/api/auth/forgot-password`, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        if (result) {
          setTimeout(() => {
            toast.success("Contraseña Modificada");
          }, 500);

          navigate("/login");
        } else {
          toast.error("Error al Modificar la Contraseña.");
        }
        // return result;
      })

      .catch((error) => toast.error("Something went wrong.", error));
  };
  return (
    <Layout title="Forgot Password">
      <form onSubmit={handleSubmit}>
        <MDBContainer
          style={{ height: "100%" }}
          fluid
          className="p-4 background-radial-gradient overflow-hidden login"
        >
          <MDBRow>
            <MDBCol
              md="6"
              className="text-center text-md-start d-flex flex-column justify-content-center"
            >
              <h1
                className="my-5 display-3 fw-bold ls-tight px-3"
                style={{ color: "hsl(218, 81%, 95%)" }}
              >
                Abgamez <br />
                <span style={{ color: "hsl(218, 81%, 75%)" }}>Store</span>
              </h1>

              <p className="px-3" style={{ color: "hsl(218, 81%, 85%)" }}>
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Eveniet, itaque accusantium odio, soluta, corrupti aliquam
                quibusdam tempora at cupiditate quis eum maiores libero
                veritatis? Dicta facilis sint aliquid ipsum atque?
              </p>
            </MDBCol>

            <MDBCol md="6" className="position-relative">
              <div
                id="radius-shape-1"
                className="position-absolute rounded-circle shadow-5-strong"
              ></div>
              <div
                id="radius-shape-2"
                className="position-absolute shadow-5-strong"
              ></div>

              <MDBCard className="my-5 bg-glass">
                <MDBCardBody className="p-5">
                  <MDBInput
                    wrapperClass="mb-4"
                    placeholder="Email"
                    id="form3"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                  <MDBInput
                    wrapperClass="mb-4"
                    placeholder="Secret Answer"
                    value={answer}
                    onChange={(e) => setAnswer(e.target.value)}
                    id="form3"
                    type="text"
                    required
                  />
                  <MDBRow className="row ">
                    <MDBCol md="10" className="col-10">
                      <MDBInput
                        wrapperClass="mb-4"
                        id="form4"
                        type={showPassword ? "text" : "password"}
                        placeholder="Password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        required
                      />
                    </MDBCol>
                    <MDBCol md="2" className="col-2">
                      <span
                        className="password-toggle-icon clickable-icon"
                        onClick={togglePasswordVisibility}
                        style={{ cursor: "pointer" }}
                        color="blue"
                      >
                        {showPassword ? (
                          <FaEyeSlash style={{ color: "black" }} />
                        ) : (
                          <FaEye style={{ color: "gray" }} />
                        )}
                      </span>
                    </MDBCol>
                  </MDBRow>

                  <MDBBtn
                    rounded
                    className="w-100 mb-4"
                    size="md"
                    type="submit"
                    style={{
                      outline: "none",
                      transform: "scale(1)",
                      height: "40px",
                    }}
                  >
                    Reset Password
                  </MDBBtn>

                  <div className="text-center mt-3">
                    <p>
                      <Link to={"/login"}>Login</Link> or{" "}
                      <Link to={"/register"}>Register</Link>
                    </p>
                  </div>
                </MDBCardBody>
              </MDBCard>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </form>
    </Layout>
  );
};

export default ForgotPassword;
